const BaseModule = require('_base/base')

class CourseSkinCover extends BaseModule {
  preInit() {
    this.$image = this.$el.find('.image')
  }

  preCalculate() {
    this.imageHeight = this.$image.height()
  }

  preRender() {
    this.$el.css({ '--coverImageHeight': this.imageHeight + 'px' })
  }

  preReset() {
    this.$el.css({ '--coverImageHeight': this.imageHeight + 'px' })
  }
}

$('.js__courseSkinCover').each((_, el) => new CourseSkinCover($(el)))
